"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./Dumpling.scss");
var _DumplingMethods = require("./DumplingMethods");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Dumpling = _ref => {
  let {
    content = {}
  } = _ref;
  const {
    header,
    icon,
    size,
    link,
    image,
    roundedImage,
    color,
    Link
  } = content;
  return (0, _DumplingMethods.renderDumpling)({
    header,
    icon,
    size,
    link,
    image,
    roundedImage,
    color,
    Link
  });
};
var _default = Dumpling;
exports.default = _default;
Dumpling.propTypes = {
  content: _propTypes.default.shape({
    header: _propTypes.default.string.isRequired,
    link: _propTypes.default.shape({
      url: _propTypes.default.string
    }),
    size: _propTypes.default.string.isRequired,
    icon: _propTypes.default.shape({
      type: _propTypes.default.string.isRequired,
      size: _propTypes.default.string.isRequired
    }),
    image: _propTypes.default.shape({
      url: _propTypes.default.string,
      altText: _propTypes.default.string
    }),
    roundedImage: _propTypes.default.bool
  })
};